import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import { getCookie } from 'docs/src/modules/utils/helpers';
import { CODE_VARIANTS } from 'docs/src/modules/constants';
import { jsx as _jsx } from "react/jsx-runtime";
var CodeVariantContext = /*#__PURE__*/React.createContext({
  codeVariant: CODE_VARIANTS.TS,
  setCodeVariant: function setCodeVariant() {}
});
if (false) CodeVariantContext.displayName = "CodeVariantContext";
if (false) {
  CodeVariantContext.displayName = 'CodeVariant';
}
function useFirstRender() {
  var firstRenderRef = React.useRef(true);
  React.useEffect(function () {
    firstRenderRef.current = false;
  }, []);
  return firstRenderRef.current;
}
export function CodeVariantProvider(props) {
  var children = props.children;
  var _React$useState = React.useState(CODE_VARIANTS.TS),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    codeVariant = _React$useState2[0],
    setCodeVariant = _React$useState2[1];
  var navigatedCodeVariant = React.useMemo(function () {
    var navigatedCodeVariantMatch = true ? window.location.hash.match(/\.(js|tsx)$/) : null;
    if (navigatedCodeVariantMatch === null) {
      return undefined;
    }
    return navigatedCodeVariantMatch[1] === 'tsx' ? CODE_VARIANTS.TS : CODE_VARIANTS.JS;
  }, []);
  var persistedCodeVariant = React.useMemo(function () {
    if (false) {
      return undefined;
    }
    return getCookie('codeVariant');
  }, []);
  var isFirstRender = useFirstRender();

  // We initialize from navigation or cookies. on subsequent renders the store is the truth
  var noSsrCodeVariant = isFirstRender === true ? navigatedCodeVariant || persistedCodeVariant || codeVariant : codeVariant;
  React.useEffect(function () {
    if (codeVariant !== noSsrCodeVariant) {
      setCodeVariant(noSsrCodeVariant);
    }
  }, [codeVariant, noSsrCodeVariant]);
  React.useEffect(function () {
    document.cookie = "codeVariant=".concat(codeVariant, ";path=/;max-age=31536000");
  }, [codeVariant]);
  var contextValue = React.useMemo(function () {
    return {
      codeVariant: codeVariant,
      noSsrCodeVariant: noSsrCodeVariant,
      setCodeVariant: setCodeVariant
    };
  }, [codeVariant, noSsrCodeVariant]);
  return /*#__PURE__*/_jsx(CodeVariantContext.Provider, {
    value: contextValue,
    children: children
  });
}
false ? void 0 : void 0;
export function useCodeVariant() {
  return React.useContext(CodeVariantContext).codeVariant;
}
export function useNoSsrCodeVariant() {
  return React.useContext(CodeVariantContext).noSsrCodeVariant;
}
export function useSetCodeVariant() {
  return React.useContext(CodeVariantContext).setCodeVariant;
}